import React from 'react';
import styled from 'styled-components';
import MuiPaper, { PaperProps } from '@material-ui/core/Paper';

const Paper: React.FC<PaperProps> = styled(MuiPaper)`
  ${({ theme }) => `
    padding: ${theme.spacing(2)}px;
    margin: ${theme.spacing(2, 'auto')};
    max-width: ${theme.breakpoints.values.sm}px;
    box-sizing: initial;
    & * {
      box-sizing: initial;
    }
  `}
`;

export default Paper;
